import styled, { css } from "styled-components";
import { md, sm } from "styles/breakpoint";
import { theme } from "styles/theme";

export const ReferralCodeStyle = styled.div`
  .referral {
    &__title {
      padding-top: 40px;
      font-size: 36px;
      color: rgb(255, 255, 255);
      font-weight: 400;
      margin-bottom: 40px;
    }
  }
  .referral__content {
    padding: 30px;
    margin-top: 60px;
    border-radius: 10px;
    background-color: ${theme.colors.black300};

    display: flex;
    align-items: center;
    gap: 50px;

    ${md(css`
      flex-direction: column;
      gap: 20px;
    `)}
    &-right {
      .header {
        margin-bottom: 20px;

        ${md(css`
          text-align: center;
        `)}

        span {
          margin-bottom: 5px;
          font-weight: 600;
          color: white;
          font-size: 16px;
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        gap: 10px;

        ${sm(css`
          flex-direction: column;
        `)}

        p {
          padding: 14px 32px;
          background-color: #252525;
          border-radius: 4px;

          color: ${theme.colors.yellow};
        }
        button {
          background: ${theme.colors.gradient[3]};
          height: 40px;
          width: 80px;
          span {
            text-transform: uppercase;
            font-weight: 600;
          }
        }
      }
    }
  }
`;
